<template>
  <div
    class="mt-3 pb-3 relative"
    :class="displayBorderBottom && 'border-inverted border-bottom border-thick'"
  >
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">Share</h2>
    <div
      class="shareaholic-canvas"
      data-app="share_buttons"
      :data-app-id="buttonsId"
      :data-title="title"
      :data-description="strippedAbstract"
      :data-link="doiUrl"
    ></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { html2text } from "~/plugins/utilities/stripHtml";

export default {
  name: "ShareButtons",
  props: {
    article: { type: Object, required: true },
    displayBorderBottom: { type: Boolean, default: true },
    buttonsId: { type: Number, default: undefined },
  },
  computed: {
    ...mapState({
      partnerName: (state) => `${state.theme.title} ${state.theme.subTitle}`,
    }),
    strippedAbstract() {
      return html2text(this.$sanitize, this.article.abstract);
    },
    strippedTitle() {
      return html2text(this.$sanitize, this.article.title);
    },
    title() {
      return `${this.strippedTitle} | ${this.partnerName}`;
    },
    doiUrl() {
      return `https://doi.org/${this.article.doi}`;
    },
  },
};
</script>
